module.exports = __webpack_public_path__ + "img/SCHEME_MOBILE.5d6cb203.svg";